import AgentActivity from 'models/agent_activity';
import AnswerPerformanceView from 'models/location/answer_performance_view';
import changeCurrentLocation from 'actions/lib/change_current_location';
import PerformanceDateRange from 'models/performance_date_range';
import SetAndLogActivity from 'actions/agent_activity/set_and_log_activity';

export default class OpenAnswerPerformance {
  constructor(context) {
    this.context = context;
  }

  run({ audienceId, dateRange, sort }) {
    const appFeatures = this.context.stores.appFeatures.get();
    if (!(appFeatures.isEnabled('viewAnswerPerformance') || appFeatures.isEnabled('answers:admin'))) {
      this.context.router.navigateHome();
      return;
    }

    if (!Object.values(PerformanceDateRange).includes(dateRange)) {
      this.context.router.navigateTo(
        AnswerPerformanceView.create({ audienceId, dateRange: PerformanceDateRange.LAST_1_DAY })
      );
      return;
    }

    changeCurrentLocation(this.context, AnswerPerformanceView.create({ audienceId, dateRange, sort }));
    this.context.executeAction(SetAndLogActivity, { type: AgentActivity.Type.ANSWER_PERFORMANCE });

    this.context.stores.answerPerformances.setLoading();
    this.context.gateways.answerPerformance.fetchAll({ audienceId, dateRange });

    this.context.stores.recommendedAnswersCounts.setLoading();
    this.context.gateways.recommendedAnswersCounts.request();
  }
}
